// Global app-wide configuration

export const ROUTING_ENABLED = true; // Toggle routing on/off for testing and development 